"use client";

import { MessageCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function NuestraHistoria() {
  const {
    ref: heroRef,
    isVisible: heroVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="hero" ref={heroRef} className="relative min-h-screen w-full flex items-center justify-center overflow-hidden">
      {}
      <div className="absolute inset-0 bg-cover bg-center bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1547753/img/hero_sunset_restaurant_beach.png)]" />
      
      {}
      <div className="absolute inset-0 bg-black/50" />

      {}
      <div className={`relative z-10 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center transition-all duration-[var(--duration-slow)] ${heroVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        {}
        <h1 className="font-display text-5xl sm:text-6xl md:text-7xl lg:text-8xl font-bold text-white mb-6 leading-tight">
          Nuestra Historia
        </h1>

        {}
        <p className="text-xl sm:text-2xl md:text-3xl text-white/90 mb-10 font-sans leading-relaxed">
          Tradición mexicana reinventada frente al mar
        </p>

        {}
        <Button asChild size="lg" className="bg-primary text-foreground-primary hover:bg-primary-hover hover:scale-105 hover:shadow-strong active:scale-100 transition-all duration-[var(--duration-fast)] ease-[var(--ease-spring)] px-8 py-6 text-lg font-semibold rounded-md shadow-medium">
          <Link to="https://wa.me/529841234567" newTab className="inline-flex items-center gap-3">
            <MessageCircle className="size-6" />
            Reservar por WhatsApp
          </Link>
        </Button>
      </div>
    </section>;
}